import React, { useState } from "react";
// import { FaFilePdf } from "react-icons/fa";
import { useGetPresentMembersListQuery } from "../../../../redux/services/internal/apiHome";
import PresentMemberModel from "./PresentMemberModel";
import Loader from "../../Components/Loader";

const PresentMembersPage = ({ benchId }) => {
  const [showModal, setShowModal] = useState(false);

  const { data: presentMembersList, isLoading } =
    useGetPresentMembersListQuery(benchId);

  const [memberDetail, setMemberDetail] = useState({});

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div className="col-12 col-sm-12 col-md-6 col-lg-9">
        <div className="chairman-detail member-detail">
          <div className="table-responsive model-mh">
            <table className="custom-table table table-striped table-bordered table-hover">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Profile Image</th>
                  <th>Name</th>
                  <th>Designation</th>
                  <th>Date of Joining</th>
                  <th>View Profile</th>
                  {/* <th>Action</th> */}
                </tr>
              </thead>
              <tbody>
                {presentMembersList.data.length > 0 ? (
                  presentMembersList.data.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>
                        <img
                          className="member-image"
                          src={item.image}
                          alt={item.name}
                        />
                      </td>
                      <td>{item.name}</td>
                      <td>{item.designation}</td>
                      <td>
                        {new Date(item.date)
                          .toLocaleDateString()
                          .replace(/\//g, "-")}
                      </td>
                      {/* <td className="text-center">
                        <a target="_blank" href={item.document}>
                          <FaFilePdf size={20} />
                        </a>
                      </td> */}
                      <td>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={() => {
                            setMemberDetail(item);
                            setShowModal(true);
                          }}
                        >
                          Details
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={7}>No Record Found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <PresentMemberModel
        setShowModal={setShowModal}
        showModal={showModal}
        memberDetail={memberDetail}
      />
    </>
  );
};

export default PresentMembersPage;
